import { CarePlanModalTask } from './useCarePlanModal'

export const anyIncompleteTask = (tasks: CarePlanModalTask[]) =>
  !!tasks.find(task => {
    if (!task.title && !task.due_date && !task.owner_group) return false
    return !task.title || !task.due_date || !task.owner_group
  })
